import React from 'react';
import { AspectRatio } from '@ff-os/shared-react/components/aspect-ratio/AspectRatio';
import { Spinner } from '@ff-os/shared-react/components/loaders/spinner/Spinner';

export const PhotoPrintSpinner = () => (
    <AspectRatio>
        <Spinner overlaySize='full' spinnerSize='medium' />
    </AspectRatio>
);